export default "__VITE_ASSET__Cmdo6pjd__"